export const PRICE = function(type, category) {
  if (type === 'Community') {
    if (category === 'Family') {
      return 8;
    }
    if (category === 'Adult') {
      return 5;
    }
    if (category === 'Youth') {
      return 2;
    }
    if (category === 'Senior') {
      return 1;
    }
    if (category === 'Child') {
      return 1;
    }
  }
  if (type === 'Associate') {
    if (category === 'Family') {
      return 15;
    }
    if (category === 'Adult') {
      return 10;
    }
    if (category === 'Youth') {
      return 4;
    }
    if (category === 'Senior') {
      return 2;
    }
    if (category === 'Child') {
      return 2;
    }
  }
};

export const LOCATION = function(lat1, lon1, lat2, lon2) {
  const R = 6371; // km (change this constant to get miles)
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  if (d > 1) return Math.round(d * 1000);
  if (d <= 1) return Math.round(d * 1000);
  return d;
};

const COMMUNITY_POLYGON_COORDS = [
  { lat: 43.65570008020407, lng: -79.41140251211341 },
  { lat: 43.65796571375469, lng: -79.40013469551562 },
  { lat: 43.64272550304969, lng: -79.39401985630343 },
  { lat: 43.639930574230846, lng: -79.40462302354061 },
  { lat: 43.63971931726911, lng: -79.40539178588364 },
  { lat: 43.6397651967047, lng: -79.40521865914786 },
  { lat: 43.65581737578668, lng: -79.4114316758833 },
];

const CATCHMENT_EDGE_TOLERANCE = 1e-6;

export const DetermineMembershipType = function(lat, long) {
  if (
    typeof window === 'undefined' ||
    !window.google ||
    !window.google.maps ||
    !window.google.maps.geometry ||
    !window.google.maps.geometry.poly
  ) {
    return 'Associate';
  }

  const point = new window.google.maps.LatLng(lat, long);
  const polygon = new window.google.maps.Polygon({
    paths: COMMUNITY_POLYGON_COORDS,
  });

  const isInside = window.google.maps.geometry.poly.containsLocation(point, polygon);
  const isOnBoundary =
    typeof window.google.maps.geometry.poly.isLocationOnEdge === 'function' &&
    window.google.maps.geometry.poly.isLocationOnEdge(point, polygon, CATCHMENT_EDGE_TOLERANCE);

  return isInside || isOnBoundary ? 'Community' : 'Associate';
};

export const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const formatePhoneNumber = (phone) => {
  const password = phone.toString().replace('-', '');
  const password1 = password.toString().replace('(', '');
  const password2 = password1.toString().replace(')', '');
  const passwordToSave = password2.toString().replace(' ', '');
  return passwordToSave;
};

export const identifyUserType = (user) => {
  if (user.userType === 'Member') {
    return 'member';
  }
  if (user.userType === 'Guest') {
    return 'guest';
  }
  return 'staff';
};

export const checkUserContactPhone = (user) => {
  if (user.phone && user.phone !== '') {
    return true;
  }
  if (user.dayPhone && user.dayPhone !== 'N/A') {
    return true;
  }
  if (user.nightPhone && (user.nightPhone === 'N/A' || user.nightPhone === '')) {
    return true;
  }
  if (user.email && user.email !== '') {
    return true;
  }
  return false;
};

export const sendErrorMessages = (state) => {
  const { messages, errors } = state;
  let fieldsvalidationResult = 0;
  Object.keys(errors).forEach((key) => {
    if (errors[key] === true || errors[key] === '') {
      fieldsvalidationResult += 1;
    }
  });
  if (fieldsvalidationResult === 0) {
    return true;
  }
  Object.keys(errors).forEach((key) => {
    if (errors[key] !== false) {
      errors[key] = true;
      messages[key] = 'Required Field!';
    }
  });
  window.scrollTo(0, 0);
  return { errors, messages };
};

export const checkFieldsValidation = (state) => {
  let validationResult = 0;
  const { errors } = state;
  Object.keys(errors).forEach((key) => {
    if (!Array.isArray(errors[key]) && typeof errors[key] !== 'object') {
      if (errors[key] === true || errors[key] === '') {
        validationResult++;
      }
    }
  });
  if (validationResult === 0) {
    return true;
  } else {
    return false;
  }
};

export const displayErrorMessages = (state) => {
  const { errors, messages } = state;
  Object.keys(errors).forEach((key) => {
    if (!Array.isArray(errors[key]) && typeof errors[key] !== 'object') {
      if (errors[key] !== false) {
        errors[key] = true;
        messages[key] = 'Required Field!';
      }
    }
  });
  window.scrollTo(0, 0);
  return { errors, messages };
};

export const getAllSeasons = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  if (month >= 0 && month <= 3) {
    return {
      winter: `Winter ${year}`,
      spring: `Spring ${year}`,
      summer: `Summer ${year}`,
      fall: `Fall ${year}`,
    };
  } else if (month >= 4 && month <= 6) {
    return {
      winter: `Winter ${year + 1}`,
      spring: `Spring ${year}`,
      summer: `Summer ${year}`,
      fall: `Fall ${year}`,
    };
  } else if (month >= 7 && month <= 9) {
    return {
      winter: `Winter ${year + 1}`,
      spring: `Spring ${year + 1}`,
      summer: `Summer ${year}`,
      fall: `Fall ${year}`,
    };
  } else if (month >= 10 && month <= 12) {
    return {
      winter: `Winter ${year + 1}`,
      spring: `Spring ${year + 1}`,
      summer: `Summer ${year + 1}`,
      fall: `Fall ${year}`,
    };
  }
};
